import React from 'react'
import { Text } from 'grommet'

const SuccessText = ({ children, ...props }) => <Text size="small" color="status-ok" {...props}>{children}</Text>

export default SuccessText